import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TextMask, InputAdapter } from "react-text-mask-hoc";
import constants from '../../utils/constants';

export class PhoneInputWithPlaceholder extends Component {
  static propTypes = {
    defaultValue: PropTypes.string,
    value: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    type: 'text',
    name: '',
  };

  render() {
    const {
      placeholder,
      defaultValue,
      value,
      onChange,
      name,
      type,
    } = this.props;
    return (
      <div className="personal-info__item">
        <TextMask
          mask={[
            "+",
            /\d/,
            " ",
            "(",
            /[1-9]/,
            /\d/,
            /\d/,
            ")",
            " ",
            /\d/,
            /\d/,
            /\d/,
            "-",
            /\d/,
            /\d/,
            /\d/,
            /\d/
          ]}
          showMask={true}
          Component={InputAdapter}
          className="personal-info__input"
          name={name}
          type={type}
          placeholder={placeholder}
          defaultValue={defaultValue}
          value={value}
          onChange={onChange}
        />
        <div className="personal-info__description">{`${placeholder}:`}</div>
        {this.props.validationFunc && this.props.value && !this.props.validationFunc(this.props.value) &&
          <span className="text-danger field-validation-error">{constants.errorMessage[this.props.name]}</span>
        }
      </div>
    );
  }
}
